(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const syncMenuState = () => {
      const isOpen = document.body.classList.contains('modal-active') && document.body.dataset.modalId === 'page-menu';
      document.querySelectorAll('[data-modal-nav-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    };

    const observer = new MutationObserver(syncMenuState);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'data-modal-id']
    });
    syncMenuState();
  })();

  } catch(e) { console.error(e); }
})();
})();
